const DonationDetailsPage = () => import('@/pages/donations/DonationDetailsPage.vue')

const DonationsIndexPage = () => import('@/pages/donations/DonationsIndexPage.vue')
const DonationAdvancedEditPage = () => import('@/pages/donations/DonationAdvancedEditPage.vue')

export default [
  { path: "/donations", name: 'DonationsIndexPage', component: DonationsIndexPage },
  { path: "/donations/:donationId/edit", name: 'DonationAdvancedEditPage', component: DonationAdvancedEditPage, props: route => ({ donationId: parseInt(route.params.donationId) }), meta: { requiresPlatformAdmin: true } },
  { path: "/donations/:donationId", name: 'DonationDetailsPage', component: DonationDetailsPage, props: route => ({ donationId: parseInt(route.params.donationId) }) },
]
